/* @flow */

import { getReadableColor } from 'plugin/light/util/lightUtils';
import { em } from 'polished';
import { lap } from '@braindate/ui/lib/token/mediaQuery';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    width: '100%',
    height: 96,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: ({ theme }: ThemeFunction) => theme.accentColor,

    [lap]: {
      minWidth: 116,
      width: 216,
      height: 'unset',
      minHeight: '100%',
    },
  },
  date: {
    fontWeight: 900,
    fontSize: em(30),
    margin: 0,
    color: ({ theme }: ThemeFunction) => getReadableColor(theme.accentColor),
  },
  time: {
    fontWeight: 600,
    fontSize: em(20),
    margin: 0,
    color: ({ theme }: ThemeFunction) => getReadableColor(theme.accentColor),
  },
};
